export const FEATURE_FLAG = {
  CURRENCY_OPTIONS: 'currency-options',
  FULL_SCREEN_CONFIG: 'full-screen-config',
  FTB_PARTICIPANT_LOGO_CDN_BASE_URL: 'ftb-participant-logo-cdn-base-url',
  HEAD_SPORT_ICONS: 'head-sport-icons',
  KYC_MAX_ATTEMPTS: 'kyc-max-attempts',
  OPENREPLAY_TRACKING: 'openreplay-tracking',
  PAYMENT_GATEWAY_OPTIONS: 'payment-gateway-options',
  PROMOTIONS_ENABLED: 'promotions-enabled',
  SKIN_OPTIONS: 'skin-options',
} as const;

export type FeatureFlagKey = (typeof FEATURE_FLAG)[keyof typeof FEATURE_FLAG];
